import { Result } from '../types';
import { normalize } from '@/utils/normalize';
import { flattenTags } from '@/utils/tags/flattenTags';

interface GetWeightedFilteredResultsProps {
  searchResults: Result[];
  activeFilters: string[];
  products: Product[];
}

type WeightedResult = {
  weight: number;
  result: Result;
};

export const getWeightedFilteredResults = ({
  searchResults,
  activeFilters,
  products,
}: GetWeightedFilteredResultsProps): WeightedResult[] => {
  // tag in title = 3 points, tag in products = 2 points, tag in description = 1 point
  const tagWeights: Record<string, number> = {};
  const slugsOfProducts: string[] = activeFilters;

  const flattenedProducts = flattenTags(products);

  searchResults.forEach(item => {
    const searchResult = item.document;

    const title: string = normalize(searchResult.derivedStructData.title);
    const products: string[] = searchResult.structData?.products || [];
    const description: string = normalize(searchResult.derivedStructData.extractive_answers?.[0].content || '');

    // check if any product is in the title.
    slugsOfProducts.forEach(product => {
      const productObject = flattenedProducts.find(p => p?.slug === product);
      const regexp = new RegExp(`\\b${productObject.title}\\b`, 'i');
      if (regexp.test(title)) {
        tagWeights[item.document.id] = (tagWeights[item.document.id] || 0) + 5;
      }
    });

    // check if any product is in the products.
    slugsOfProducts.forEach(product => {
      if (products.includes(product)) {
        tagWeights[item.document.id] = (tagWeights[item.document.id] || 0) + 2;
      }
    });

    // check if any product is in the description.
    slugsOfProducts.forEach(product => {
      const productObject = flattenedProducts.find(p => p?.slug === product);
      const regexp = new RegExp(`\\b${productObject.title}\\b`, 'i');
      if (regexp.test(description)) {
        tagWeights[item.document.id] = (tagWeights[item.document.id] || 0) + 1;
      }
    });
  });

  const weights = searchResults.map(result => ({
    weight: tagWeights[result.document.id] || 0,
    result,
  }));

  const filteredResults = weights.filter(weightedResult => weightedResult.weight > 0);

  return filteredResults;
};
